// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 386 ? "03c2479a" : chunkId) + "." + {"47":"5851472cc411fd75","386":"eabc5eaae7a3ef11","452":"4b59dc429821611c","723":"75aeb3b837ae72bd","731":"4ae4b141cfa19671","778":"ab78891f5d4db9a4"}[chunkId] + ".js";
};